import React from 'react';
import { getThemeColors } from '../../../../lib/theme';

/**
 * „‹ Zurück"-Button. Mit `compact` (Header auf dem Handy) nur das Chevron —
 * der Text „Zurück zu den Konten" sprengte sonst die 64px-Navbar und lag über
 * Theme-/Sprach-Schaltern. Der Text bleibt als aria-label/title erhalten.
 */
export function BackBar({ dark, onBack, label, compact }: { dark: boolean; onBack: () => void; label: string; compact?: boolean }) {
  const t = getThemeColors(dark);
  const iconOnly = compact === true;
  return (
    <button
      type="button"
      onClick={onBack}
      aria-label={label}
      title={label}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, alignSelf: iconOnly ? 'center' : 'flex-start',
        flexShrink: 0, whiteSpace: 'nowrap',
        background: 'transparent', border: `1px solid ${t.border}`, borderRadius: 8,
        padding: iconOnly ? 0 : '6px 12px', width: iconOnly ? 38 : undefined, height: iconOnly ? 38 : undefined,
        cursor: 'pointer', color: t.text, fontSize: 13, fontFamily: 'Outfit,sans-serif',
      }}
    >
      <span aria-hidden="true" style={{ fontSize: iconOnly ? 20 : 16, lineHeight: 1 }}>‹</span>
      {!iconOnly && <> {label}</>}
    </button>
  );
}
